import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ExtraReducer,
  convertBackgroundEventToBlogPost,
  getSideEffectState,
  maybeEmptyArray,
} from '@utils/.';
import { BlogReducerProps } from '../type';
import { backgroundEventApiService, blogApiService } from '@services/service-register';
import { BlogPostStage } from '@core/models';

export const fetchLocationBlogPosts = createAsyncThunk(
  'blog/fetchLocationBlogPosts',
  async (_, thunkApi) => {
    try {
      const backgroundEvents = await backgroundEventApiService.getBlogGenerateEvents();
      const blogPosts = await blogApiService.getLocationBlogPosts();
      return [
        ...maybeEmptyArray(blogPosts).filter(
          blogPost => blogPost.status !== BlogPostStage.ApprovalRequested
        ),
        ...backgroundEvents.map(convertBackgroundEventToBlogPost),
      ];
    } catch (error: any) {
      return undefined;
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(fetchLocationBlogPosts);

export const fetchLocationBlogPostsReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
    state.blogPosts = action.payload;
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
    state.blogPosts = [];
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<BlogReducerProps>;
